"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ServiceLogger = exports.DiagnosticsLogger = void 0;
const logger_base_1 = require("./logger-base");
const flat_1 = __importDefault(require("flat"));
const consoleLogger = {
    info: console.log,
    imp: console.log,
    warn: console.warn,
    err: console.error,
};
class DiagnosticsLogger extends logger_base_1.DiagnosticsLoggerBase {
    constructor(logLevel) {
        super(logLevel, false);
        this.logger = consoleLogger;
    }
    log(style, content) {
        this.logger[style](content);
    }
}
exports.DiagnosticsLogger = DiagnosticsLogger;
class ServiceLogger extends logger_base_1.ServiceLoggerBase {
    constructor(service, logLevel) {
        super(service, logLevel, false);
    }
    format(serviceLog) {
        return JSON.stringify(flat_1.default(serviceLog));
    }
}
exports.ServiceLogger = ServiceLogger;
//# sourceMappingURL=loggers-browser.js.map